import React, { useState, useEffect } from "react";
import { Button, Col, Row, Spinner } from "reactstrap";
import CustomSelect from "components/customs/dropdown";
import { AlertCircle, Plus } from "react-feather";
import { Toast, getFormattedOptions, hasPermission } from "utility/helpers";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import _ from "lodash";
import Swal from "sweetalert2";
import {
  assignProjectCongressman,
  fetchAllAgencies,
  fetchAllAgencyProjects,
  validateBudgetRequest,
} from "services/services.projects";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchAllRegions,
  fetchCongressmanDetails,
} from "services/services.congressman";
import { congressmanSearch } from "services/services.navbar";
import {
  ACCOUNT_SUPER_ADMIN,
  congRoles,
  SUPER_ADMIN_ACCOUNTS,
} from "utility/constants";
import { addProjectDropdownStyles } from "constants/style";
import { useNavigate } from "react-router";
import api from "services/api";
import { genericGet } from "services/services.general";
import { useDispatch } from "react-redux";
import useAuth from "hooks/useAuth";
import LoadingScreen from "components/customs/loading-screen";
import { ADD_ACTION } from "constants/actions";
import styled from "styled-components";
import {
  AddButton,
  FormLabel,
  HeaderText,
  StyledFontAwesomeIcon,
} from "assets/js/Styles";
import FormGenerator from "components/customs/form-generator/input";
import { AGENCY_DOH_ID, AGENCY_DOH_MAIP_ID } from "constants/agency";
import AddProgramForm from "./Form";
import { fetchPendingProjects } from "../../../redux/actions/projects";
import {
  defaultProjectRecipients,
  isAddProgramIconShown,
  isFormEnabled,
  isSendRequestFormShown,
} from "./constants";
import { getFormData, validate } from "./utility";

const StyledSaveButton = styled(AddButton)`
  background: ${({ theme }) => theme.colors.buttonFormBlue};
  width: 130px;
`;

const AdvisorySection = styled.div`
  display: flex;
`;

const AddRowButton = styled(Button)`
  width: 100%;
  border: 1px dashed ${({ theme }) => theme.colors.blue50};
  border-radius: 4px;
  background-color: transparent;
  color: ${({ theme }) => theme.colors.blue50};
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 400;
  font-size: 15px;
`;

const WarningParagraph = styled.p`
  color: #f0ad4e;
  margin: 0;
`;

const HouseMemberSection = styled(Row)`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;
`;

const HouseMemberColRight = styled.div`
  display: grid;
  grid-template-columns: 1fr 107px;

  @media screen and (max-width: 575.98px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;

const AdvisoryParagraph = styled.p`
  color: #5a189a;
  border-left: 4px solid #5a189a;
  padding-left: 10px;
  margin: 0;
`;

const AddRowSection = styled(Row)`
  margin-top: 2.5rem;
  margin-bottom: 0;
  margin-left: 0;
  margin-right: 0;
  display: flex;
  padding: 1rem;
  justify-content: flex-end;
  padding-right: 107px;
`;

const RightFieldSection = styled.div`
  display: grid;
  grid-template-columns: 1fr 107px;

  @media screen and (max-width: 575.98px) {
    grid-template-columns: 1fr;
    row-gap: 12px;
  }
`;

const AddProjectButton = styled.div`
  width: 107px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-left: 1rem !important;
  text-decoration: none;
  color: initial;
  padding: 0;
  font-style: italic;
  cursor: pointer;
`;

const CancelAddProjectSection = styled.div`
  cursor: pointer;
  align-items: center;
  display: flex;
  width: 107px;
  padding-left: 1rem !important;
`;

const Wrapper = styled.div`
  margin-top: 50px;
`;

const HeaderTextSection = styled.div`
  margin-top: 24px;
  display: grid;
  justify-content: space-between;
  grid-auto-flow: column;
  align-items: center;

  h2 {
    margin-bottom: 0;
  }

  a {
    text-decoration: none;
  }

  @media (max-width: 575.98px) {
    grid-template-columns: 1fr 50px;

    a {
      display: flex;
      justify-content: flex-end;
    }

    padding-top: 4rem;
  }
`;

const MainContainer = styled.div`
  margin-top: 44px;
`;

const AddProjectFormSection = styled.div`
  margin: 0;
  display: flex;
  margin-top: 2rem;
  justify-content: space-between;
  flex-direction: column;
`;

const ActionButtonSection = styled(Row)`
  padding-top: 2rem;
  margin: 0;
  padding-bottom: 4rem;
  display: flex;
  justify-content: flex-end;
`;

const SendAnotherRequestSection = styled(Col)`
  display: flex;
  justify-content: flex-end;
`;

const SaveButtonSection = styled(Col)`
  display: flex;
  justify-content: flex-end;
  display: grid;
  grid-template-columns: 1fr 107px;
  padding: 0;
`;

const SendAnotherRequestBtn = styled(AddButton)`
  background: ${({ theme }) => theme.colors.blue};
  color: ${({ theme }) => theme.colors.white};
`;

const SendAnotherRequestText = styled.p`
  margin: 0;
  margin-left: 2px;
`;

const AddProjectComponent = () => {
  const dispatch = useDispatch();

  const [agencyOptions, setAgencyOptions] = useState([]);
  const [projectOptions, setProjectOptions] = useState([]);
  const [selectedAgency, setSelectedAgency] = useState(null);
  const [selectedProject, setSelectedProject] = useState(null);
  const [regionOptions, setRegionOptions] = React.useState([]);
  const [action, setAction] = useState("");

  const [projectRecipients, setProjectRecipients] = useState([
    defaultProjectRecipients,
  ]);

  const [selectedCourses, setSelectedCourses] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFormLoading, setFormIsLoading] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [isFormResetted, setIsFormResetted] = useState(false);

  const [projectDetailsFormData, setProjectDetailsFormData] = useState({
    agency: "",
    project: "",
    recipients: [],
    projectName: "",
  });

  const { user } = useAuth();
  const role = user?.type;
  const cong = user?.congressman || null;

  const navigate = useNavigate();

  const isRoleCongressman = congRoles.includes(role);

  const fetchAgencies = () => {
    fetchAllAgencies({
      callback: (data) => {
        const newData = getFormattedOptions("name", data);
        setAgencyOptions(newData);
      },
    });
  };

  const fetchProjects = () => {
    fetchAllAgencyProjects({
      url: `/agency/${selectedAgency?.value}`,
      callback: (data) => {
        let projects = data?.Projects;

        if (selectedAgency?.value === 14) {
          projects = data?.Projects.filter(
            (project) => project.name === "Infrastructure"
          );
        }

        const options = getFormattedOptions("name", projects);
        if (selectedAgency?.value === 14) setSelectedProject(options[0]);
        setProjectOptions(options);
      },
    });
  };

  const handleDeleteRow = (e, index) => {
    e.preventDefault();
    const newProjectRecipients = [...projectRecipients];
    newProjectRecipients.splice(index, 1);
    setProjectRecipients(newProjectRecipients);
  };

  const handleAddRow = () => {
    const newProjectRecipients = [...projectRecipients];
    newProjectRecipients.push(defaultProjectRecipients);
    setProjectRecipients(newProjectRecipients);
  };

  const handleSearchInputOnChange = (value, index) => {
    const newProjectRecipients = [...projectRecipients];

    const region = regionOptions.find((reg) => reg.value === value.region.id);

    const newValue =
      value.region.id !== 18
        ? {
            ...value,
            region,
          }
        : {
            ...value,
            region: null,
          };

    newProjectRecipients[index] = {
      ...newProjectRecipients[index],
      recipientName: newValue,
      allocationType: defaultProjectRecipients.allocationType,
    };

    setProjectRecipients(newProjectRecipients);
  };

  const resetForm = () => {
    if (!isRoleCongressman) setProjectRecipients([defaultProjectRecipients]);
    setSelectedProject(null);
    setSelectedAgency(null);
    setUploadedFiles([]);

    setProjectDetailsFormData({
      agency: "",
      project: "",
      recipients: [],
      projectName: "",
    });

    setIsFormResetted(true);
  };

  const AssignCong = (congressmenData) => {
    assignProjectCongressman({
      formData: congressmenData,
      callback: ({ isSuccess, msg }) => {
        setIsLoading(false);

        if (isSuccess) {
          if (SUPER_ADMIN_ACCOUNTS.includes(role)) {
            dispatch(fetchPendingProjects());
          }

          const text = msg.replace(/\n/g, "<br>");

          Swal.fire({
            html: text,
            icon: "success",
            customClass: text.includes("<br>")
              ? { container: "sms-notif" }
              : null,
          }).then((result) => {
            if (result.isConfirmed && isRoleCongressman) {
              navigate(`/representatives/${cong.region.id}/cong/${cong.id}`);
            }
          });
          resetForm();
        } else {
          Swal.fire({
            title: "Error",
            text: msg,
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      },
    });
  };

  const AddProject = async (modalValue = {}) => {
    try {
      const projData = {
        agencyId: selectedAgency.id,
        name: projectDetailsFormData.projectName,
      };
      let projectId = null;

      await new Promise((resolve, reject) => {
        api({
          Method: "POST",
          Url: "/project",
          Data: projData,
          ResponseSuccessCallback: (response) => {
            if (response && response?.request?.status === 201) {
              projectId = response?.data?.data?.id;
              resolve(response);
            } else {
              reject(new Error("Failed to create program"));
            }
          },
          ResponseErrorCallback: (error) => {
            reject(error);
          },
        });
      });

      if (!projectId) {
        throw new Error("Failed to get program ID");
      }

      const data = getFormData({
        uploadedFiles,
        selectedAgency,
        selectedProject,
        projectId,
        projectRecipients,
        selectedCourses,
      });

      AssignCong({
        ...data,
        sendOnlyToSuperAdmin: Boolean(modalValue?.sendOnlyToSuperAdmin),
      });
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);

      setIsLoading(false);

      Swal.fire({
        title: "Error",
        text: "There was an error while assigning congressmen to the program",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const validateRequest = () => {
    setFormIsLoading(true);

    return new Promise((resolve) => {
      validateBudgetRequest({
        id: cong?.id,
        formData: {
          projectId: selectedProject?.value,
          budget: projectRecipients[0].budgetAllocation ?? null,
        },
        callback: ({ isSuccess, msg }) => {
          setFormIsLoading(false);

          if (!isSuccess) {
            resetForm();

            Swal.fire({
              title: "Error",
              text: msg,
              icon: "error",
              confirmButtonText: "OK",
            });

            resolve(false);
          } else {
            resolve(true);
          }
        },
      });
    });
  };

  const handleSaveForm = async () => {
    const isValid = await validate({
      projectRecipients,
      selectedAgency,
      selectedProject,
      selectedCourses,
      uploadedFiles,
      role,
    });

    if (typeof isValid === "boolean") {
      if (isRoleCongressman) {
        const budgetOk = await validateRequest();

        if (!budgetOk) {
          return;
        }
      }

      let result = null;

      if (role === ACCOUNT_SUPER_ADMIN) {
        result = await Swal.fire({
          title: "Warning",
          icon: "warning",
          html: `
          <p style="text-align: center; margin-bottom: 1rem;">
            Are you sure you want to proceed?
          </p>
          <div style="text-align: center; margin-top: 1rem;">
            <label style="align-items: center;">
              <input type="checkbox" id="swal-add-no-sms" checked
                style="margin-right: 0.5rem;">
              <span>
                Do not send SMS notifications to Directors, Editors,
                and Agencies.
              </span>
            </label>
          </div>
        `,
          confirmButtonText: "OK",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          preConfirm: () => ({
            sendOnlyToSuperAdmin: document.getElementById("swal-add-no-sms")
              ?.checked
              ? 1
              : 0,
          }),
          focusConfirm: false,
        });

        if (!result.isConfirmed) {
          return;
        }
      }

      setIsLoading(true);

      if (!selectedProject) {
        AddProject(result?.value);
      } else {
        const data = getFormData({
          uploadedFiles,
          selectedAgency,
          selectedProject,
          projectId: selectedProject.value,
          projectRecipients,
          selectedCourses,
        });

        AssignCong({
          ...data,
          sendOnlyToSuperAdmin: Boolean(result?.value?.sendOnlyToSuperAdmin),
        });
      }
    } else {
      Toast({
        type: 4,
        content: isValid,
      });
    }
  };

  const handleCongressmanSearch = _.debounce((inputValue, callback) => {
    congressmanSearch({
      inputValue,
      callback,
    });
  }, 1000);

  const setFirstEntry = () => {
    const { congressman } = user;

    fetchCongressmanDetails({
      url: `/congressman/${congressman.id}`,
      callback: (data) => {
        const value = {
          recipientName: {
            value: data.id,
            label: data.fullName,
            region:
              data.District.Region.id !== 18
                ? {
                    id: data.District.Region.id,
                    value: data.District.Region.id,
                    label: data.District.Region.acronym,
                    acronym: data.District.Region.acronym,
                  }
                : null,
          },
        };

        const newProjectRecipients = [...projectRecipients];

        newProjectRecipients[0] = {
          ...newProjectRecipients[0],
          ...value,
        };

        setProjectRecipients(newProjectRecipients);
      },
    });
  };

  const fetchRegion = () => {
    fetchAllRegions({
      params: {
        includeCentral: true,
      },
      callback: (data) => {
        if (data.length) {
          const options = data
            .filter((region) => region.name !== "Partylist")
            .map(({ acronym, id, omegaId }) => ({
              omegaId,
              label: acronym,
              value: id,
            }));

          setRegionOptions(options);
        }
      },
    });
  };

  const fetchUtilization = () => {
    setFormIsLoading(true);

    genericGet({
      url: `/project/${selectedProject?.value}/${cong?.id}/utilization-needed`,
      callback: (res) => {
        if (res) {
          Swal.fire({
            title: "Info",
            // eslint-disable-next-line max-len
            text: `You cannot request for additional budget for ${selectedProject?.label} at this time. Please provide utilization reports for previous allocations via Utilization Reports tab. Thank you!`,
            icon: "info",
            confirmButtonText: "OK",
          });
        } else {
          setFormIsLoading(false);
        }
      },
    });
  };

  useEffect(() => {
    //  fetch all agencies
    fetchAgencies();
    fetchRegion();

    if (isRoleCongressman) setFirstEntry();
  }, []);

  useEffect(() => {
    if (selectedAgency) {
      // reset selected project on agency change
      setSelectedProject(null);
      setUploadedFiles([]);
      fetchProjects();
    }
  }, [selectedAgency]);

  useEffect(() => {
    if (selectedProject && isRoleCongressman) {
      fetchUtilization();
      validateRequest();
    }
  }, [selectedProject]);

  if (!user) {
    return <LoadingScreen />;
  }

  return (
    <Wrapper>
      <Col className="container">
        <HeaderTextSection>
          <HeaderText>{"Projects"}</HeaderText>
        </HeaderTextSection>
        <MainContainer>
          {hasPermission("agency-view") && (
            <HouseMemberSection>
              <Col
                xs="12"
                md="6"
              >
                <FormLabel>{"Agency"}</FormLabel>
                <p>{"Provide the name of the agency"}</p>
              </Col>
              <Col
                xs="12"
                md="6"
              >
                <RightFieldSection>
                  <CustomSelect
                    placeholder="Agency"
                    styles={addProjectDropdownStyles}
                    options={agencyOptions}
                    value={selectedAgency}
                    onChange={(option) => {
                      setSelectedAgency(option);
                    }}
                    filterOption={(option, searchValue) =>
                      option?.label
                        ?.toLowerCase()
                        ?.includes(searchValue?.toLowerCase()) ||
                      option?.data?.acronym
                        ?.toLowerCase()
                        ?.includes(searchValue?.toLowerCase())
                    }
                  />
                </RightFieldSection>
              </Col>
            </HouseMemberSection>
          )}

          <HouseMemberSection>
            <Col
              xs="12"
              md="6"
            >
              <FormLabel>{"Program"}</FormLabel>
              <p>{"Provide the name of the program"}</p>
            </Col>
            <Col
              xs="12"
              md="6"
            >
              <RightFieldSection>
                {action === ADD_ACTION ? (
                  <FormGenerator
                    type="text"
                    placeholder="Program"
                    onChange={(e) => {
                      const { value } = e.target;

                      setProjectDetailsFormData({
                        ...projectDetailsFormData,
                        projectName: value,
                      });
                    }}
                    value={projectDetailsFormData?.projectName}
                  />
                ) : (
                  <CustomSelect
                    placeholder="Program"
                    styles={addProjectDropdownStyles}
                    options={projectOptions}
                    value={selectedProject}
                    onChange={(option) => setSelectedProject(option)}
                    isDisabled={
                      selectedAgency === null || selectedAgency?.value === 14
                    }
                  />
                )}

                {isAddProgramIconShown(action, role, selectedAgency) ? (
                  <AddProjectButton
                    onClick={() => {
                      setAction(ADD_ACTION);
                      setSelectedProject(null);

                      if (!isRoleCongressman) {
                        setProjectRecipients([defaultProjectRecipients]);
                      }

                      setProjectDetailsFormData({
                        agency: "",
                        project: "",
                        recipients: [],
                        projectName: "",
                      });
                    }}
                  >
                    {"Send Request"}
                  </AddProjectButton>
                ) : null}

                {action === ADD_ACTION ? (
                  <CancelAddProjectSection>
                    <StyledFontAwesomeIcon
                      size="xl"
                      icon={faCircleXmark}
                      onClick={(e) => {
                        e.preventDefault();
                        setAction("");
                        resetForm();
                      }}
                    />
                  </CancelAddProjectSection>
                ) : null}
              </RightFieldSection>
            </Col>
          </HouseMemberSection>

          {isSendRequestFormShown(
            action,
            selectedProject,
            selectedAgency,
            isFormLoading
          ) ? (
            <>
              <hr />

              <HouseMemberSection>
                <Col
                  xs="12"
                  md="6"
                />
                <Col
                  xs="12"
                  md="6"
                >
                  <HouseMemberColRight>
                    <AdvisorySection>
                      <WarningParagraph>
                        <AlertCircle size={16} />
                        {
                          " Please note that the Program Request is subject to the agency's approval and must comply with its guidelines."
                        }
                      </WarningParagraph>
                    </AdvisorySection>
                  </HouseMemberColRight>
                </Col>
              </HouseMemberSection>

              {selectedAgency?.value === AGENCY_DOH_ID &&
                selectedProject?.value === AGENCY_DOH_MAIP_ID && (
                  <HouseMemberSection>
                    <Col
                      xs="12"
                      md="6"
                    />
                    <Col
                      xs="12"
                      md="6"
                    >
                      <HouseMemberColRight>
                        <AdvisorySection>
                          <AdvisoryParagraph>
                            {
                              " For the remaining quarter of the year, Guarantee Letters (GLs) under DOH MAIP may only be issued to Government hospitals"
                            }
                          </AdvisoryParagraph>
                        </AdvisorySection>
                      </HouseMemberColRight>
                    </Col>
                  </HouseMemberSection>
                )}

              <AddProjectFormSection>
                {projectRecipients?.map((recipient, index) => {
                  return (
                    <>
                      <AddProgramForm
                        // eslint-disable-next-line react/no-array-index-key
                        key={index}
                        agency={selectedAgency?.value}
                        handleSearchInputOnChange={handleSearchInputOnChange}
                        index={index}
                        handleCongressmanSearch={handleCongressmanSearch}
                        recipient={recipient}
                        projectRecipients={projectRecipients}
                        handleDeleteRow={handleDeleteRow}
                        setProjectRecipients={setProjectRecipients}
                        selectedProject={selectedProject?.value}
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        setIsFormResetted={setIsFormResetted}
                        isFormResetted={isFormResetted}
                        regionOptions={regionOptions}
                        selectedCourses={selectedCourses}
                        setSelectedCourses={setSelectedCourses}
                      />

                      {projectRecipients.length !== index + 1 ? <hr /> : null}
                    </>
                  );
                })}
              </AddProjectFormSection>
              <AddRowSection>
                {!isRoleCongressman && selectedAgency?.value !== 14 ? (
                  <AddRowButton onClick={() => handleAddRow()}>
                    {"Add Row"}
                  </AddRowButton>
                ) : null}
              </AddRowSection>
            </>
          ) : null}

          <ActionButtonSection>
            {action === ADD_ACTION ? (
              <SendAnotherRequestSection xs="auto">
                <SendAnotherRequestBtn
                  outline
                  disabled={isFormEnabled(
                    isLoading,
                    action,
                    selectedAgency,
                    projectDetailsFormData,
                    selectedProject,
                    projectRecipients
                  )}
                  onClick={() => resetForm()}
                >
                  <Plus />
                  <SendAnotherRequestText>
                    {"Send Another Request"}
                  </SendAnotherRequestText>
                </SendAnotherRequestBtn>
              </SendAnotherRequestSection>
            ) : null}

            {hasPermission("project-create") && (
              <SaveButtonSection xs="auto">
                <StyledSaveButton
                  color="primary"
                  onClick={() => handleSaveForm()}
                  disabled={isFormEnabled(
                    isLoading,
                    action,
                    selectedAgency,
                    projectDetailsFormData,
                    selectedProject,
                    projectRecipients
                  )}
                >
                  {isLoading ? (
                    <Spinner
                      animation="border"
                      color="light"
                      size="sm"
                    />
                  ) : (
                    "Save"
                  )}
                </StyledSaveButton>
              </SaveButtonSection>
            )}
          </ActionButtonSection>
        </MainContainer>
      </Col>
    </Wrapper>
  );
};

export default AddProjectComponent;
